import { Container, Title, Stack, Text, Divider } from '@mantine/core';
import { GeneralSettings } from './components/GeneralSettings';
import { SubscriptionSettings } from './components/SubscriptionSettings';
import { usePermissions } from '@/hooks/usePermissions';

export function SettingsPage() {
  const { canAccess } = usePermissions();
  const canViewBilling = canAccess('billing');

  return (
    <Container fluid>
      <Stack gap="lg">
        <div>
          <Title order={1}>Account & Billing</Title>
          <Text c="dimmed" size="sm">
            Manage your organization settings, account information, and subscription
          </Text>
        </div>

        <GeneralSettings />

        {canViewBilling && (
          <>
            <Divider my="md" />
            <SubscriptionSettings />
          </>
        )}
      </Stack>
    </Container>
  );
}
